import React, { useState, useEffect, createRef, useRef } from 'react';

import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';

import {
    IconButton,
    Button,
    MenuItem,
    Popover,
    TextField,
    Dialog,
    DialogContent,
    DialogActions,
    ListSubheader,
    DialogContentText
} from '@material-ui/core';
import {
    getProjectNameOfField,
    isSystemField,
    isProjectUsingSystemForm,
    duplicateField,
    showFieldInfo,
    removeFieldInFieldList,
    onClickUsingProjects,
    onBeforeDragStartHandlerFieldList,
    onDragEndHandlerFieldList,
    getFieldListInCorp,
    onSubmitAddField,
    autoScrollToEditField,
    initObserverAddField,
    handleEventChangeFieldFilter,
    getSelectProjectList,
    deleteFieldById,
    getNewOrderForNewField,
} from '@/component/formManagement/handler/FieldListHandler';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { fieldListOfProjectSelector } from '@/state/selector/formSelector';
import { formListOfProjectSelector } from '@/state/selector/formSelector';
import { corporationAtom } from '@/state/atom/corporationAtom';
import { projectInuseDetailAtom, projectListInCorporationAtom } from '@/state/atom/projectAtom';
import { panelSettingAtom } from '@/state/atom/panelAtom';
import systemField, {
    TmpHiddenSystemField,
    ForceActiveSystemFields,
    AISystemField
} from '@/common/constant/SystemField';
import { userAtom } from '@/state/atom/userAtom';
import { useSnackbar } from 'notistack';
import { DragDropContext, Draggable, Droppable } from '@react-forked/dnd';
import {
    getAddFieldByFieldType,
    isAddNewField,
    isUseFieldInForm,
    isPermissionDeleteField,
    isEditField,
    getIconFieldByTypeField,
    sortFieldListByOrder,
    sortFieldListByDictionary,
    sortProjectByprojectInuseAndDictionary,
    addFieldNew,
} from '@/component/formManagement/handler/CommonHandler';
import { cloneDeep } from 'lodash-es';
import AddFieldTagItem from './addField/AddFieldTagItem';
import AddFieldStatusItem from './addField/AddFieldStatusItem';
import { I18n } from 'aws-amplify';
import { duplicateField as duplicateFieldInForm } from '@/component/formManagement/handler/FormListHandler';
import CancelTabsDialog from '../system/dialog/CancelTabsDialog';
import { closeTabId, multiPanelAtom } from '@/state/atom/panelAtom';
import { closePanelTabSelector } from '@/state/selector/panelSelector';
import OverFlowTooltipWithTabsMui from '../common/OverFlowTooltipWithTabsMui';
import ReactDOM from "react-dom";

function ConfirmDeleteFieldModal(props) {
    const handleCloseConfirmModal = () => {
        props.setMoreActionPopover(null);
        props.setIsOpenConfirmDeleteModal(false);
    };

    return (
        <Dialog
            open={props.isOpenConfirmDeleteModal}
            onClose={() => handleCloseConfirmModal()}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="wrapDialog"
            data-cy="field-list-delete-dialog"
        >
            {/* <DialogTitle className="titleHeader">
                <div className="title">確認</div>
                <IconButton className="close" onClick={() => handleCloseConfirmModal()}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle> */}
            <DialogContent>
                <div className="confirm-dialog-content">{I18n.get('COMMSG025')}</div>
            </DialogContent>
            <DialogActions className="confirm-dialog-action">
                <Button
                    className="confirm-dialog-button"
                    variant="contained"
                    color="primary"
                    onClick={event => {
                        props.setMoreActionPopover(null);
                        props.submitConfirm();
                    }}
                    data-cy="dialog-btn-delete"
                >
                    {I18n.get('COMBTN002')}
                </Button>
                <Button
                    className="confirm-dialog-button"
                    variant="contained"
                    color="primary"
                    onClick={(event, reason) => handleCloseConfirmModal(event, reason)}
                    data-cy="dialog-btn-cancel"
                >
                    {I18n.get('COMBTN007')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}


function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
  }

export default function FieldList(props) {
    // item menu tabs
    const [anchorEl, setAnchorEl] = React.useState(null);
    const DONT_DISPLAY_SYS_FIELDS = [...Object.values(Constant.AI_AUTO.SYSTEM_FIELD), ...Object.values(Constant.SD_AUTO.SYSTEM_FIELD)];
    const open = Boolean(anchorEl);
    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    // end item menu tabs

    const [argsFormFilter, setArgsFormFilter] = useState({
        formType: Constant.FORM_TYPE.FORM_REQ_QA,
        formLevel: 'all',
        formStatus: 'all'
    });

    const [listProjectInCorp, setListProjectInCorp] = useState([]);
    const [fieldListInState, setFieldListInState] = useRecoilState(fieldListOfProjectSelector);
    // common corporationDetail state
    const corporationDetail = useRecoilValue(corporationAtom);
    const projectDetail = useRecoilValue(projectInuseDetailAtom);
    const [useButtonCollapse, setUseButtonCollapse] = useState(true);
    const [unUseButtonCollapse, setUnUseButtonCollapse] = useState({flag: true, });

    const [settingSlideRecoilState, setSettingSlideRecoilState] = useRecoilState(panelSettingAtom);

    // isOpenConfirmDeleteModal
    const [isOpenConfirmDeleteModal, setIsOpenConfirmDeleteModal] = useState(false);

    // dummy id of block msg
    const blockFieldListId = `dummy_${Date.now().toString()}`;
    const [newFieldId, setNewFieldId] = useState('');
    const [isAutoScrollToAddField, setIsAutoScrollToAddField] = useState(false);

    // screen name
    const [panelScreen, setPanelScreen] = useState(Constant.FORM_MANAGEMENT_SCREEN.LIST_FIELD);

    // system field list
    const [systemFieldList, setSystemFieldList] = useState(systemField);

    // common userDetail state
    const userDetail = useRecoilValue(userAtom);

    // common fieldDragDropList
    const [fieldDragDropList, setFieldDragDropList] = useState([]);

    // filter
    const [fieldFilter, setFieldFilter] = useState({
        type: 'all',
        usingForm: 'all'
    });

    // common projectList state
    const projectList = useRecoilValue(projectListInCorporationAtom);

    const [fieldRefList, setFieldRefList] = useState({});

    const [fieldList, setFieldList] = useState([]);
    const [fieldAddList, setFieldAddList] = useState([]);

    // component state
    const { enqueueSnackbar } = useSnackbar();

    // fieldType popover
    const [fieldTypePopover, setFieldTypePopover] = useState(null);
    const isOpenFieldTypePopover = Boolean(fieldTypePopover);
    const id = isOpenFieldTypePopover ? 'simple-popover' : undefined;

    // more action popover
    const [moreActionPopover, setMoreActionPopover] = useState(null);
    const isOpenMoreActionPopover = Boolean(moreActionPopover);
    const [currentFieldSelected, setCurrentFieldSelected] = useState(null);
    //  const id = isOpenFieldTypePopover ? 'simple-popover' : undefined;

    // fieldType
    const [fieldTypeSelectedList, setFieldTypeSelectedList] = useState([]);

    // field use list
    const [fieldUseList, setFieldUseList] = useState([]);
    const [fieldSystemUseList, setFieldSystemUseList] = useState([]);
    // field unuse list
    const [fieldUnUseList, setFieldUnUseList] = useState([]);
    const prevFieldUnUseList = usePrevious(fieldUnUseList);

    const [fieldSystemUnUseList, setFieldSystemUnUseList] = useState([]);
    const [listIdOfListUseField,setListIdOfListUseField ] = useState([])

    // common form
    const formList = useRecoilValue(formListOfProjectSelector);

    // fieldListForUpdate
    const [fieldLisForUpdate, setFieldLisForUpdate] = useState({});

    const isUsingSystemFormInvite = isProjectUsingSystemForm(formList);
    const isUsingSystemFormQA = isProjectUsingSystemForm(formList, Constant.FORM_TYPE.FORM_REQ_QA);
    const isUsingSystemFormExternalDeskRequest = isProjectUsingSystemForm(
        formList,
        Constant.FORM_TYPE.FORM_REQ_EXTERNAL_DESK
    );
    const isUsingSystemFormCustomerInvite = isProjectUsingSystemForm(
        formList,
        Constant.FORM_TYPE.FORM_REQ_INVITE_GUEST_CUSTOMER
    );

    const [currentUpdateField, setCurrentUpdateField] = useState({});

    const [parentPanelScreen, setParentPanelScreen] = useState(
        Constant.FORM_MANAGEMENT_SCREEN.LIST_FIELD
    );

    const [addFieldShow, setAddFieldShow] = useState(false);

    const [isChangeData, setIsChangeData] = useState(false);
    const [ isAllFieldValid, setIsAllFieldValid] = useState(true);
    const [isDisableButtonSubmit, setIsDisableButtonSubmit] = useState(true)
    

    const [isEditedData, setIsEditedData] = useState(false);
    
    useEffect(()=>{
    },[isChangeData])


    useEffect(() => {
    }, [fieldAddList]);

    const closePanelTab = useSetRecoilState(closePanelTabSelector);
    const [closeTabIdState, setCloseTabIdState] = useRecoilState(closeTabId);
    const [panelList, setPanelList] = useRecoilState(multiPanelAtom);
    const [isConfirmCancelTabs, setIsConfirmCancelTabs] = useState(false);
    const [isCancelAddFieldTag, setIsCancelAddFieldTag] = useState(false);
    const [isCancelAddFieldStatus, setIsCancelAddFieldStatus] = useState(false);
    const [listCorpSharedField, setListCorpSharedField] = useState([]);
    const[triggerReload,setTriggerReload] = useState(false);
    const [listFormOfAffiliationProject,setListFormOfAffiliationProject] = useState([])
    const [isOpenPopupCannotInactiveField,setIsOpenPopupCannotInactiveField] = useState(false)

    const [popoverId, setPopoverId] = useState();
    const [paginationScroll, setPaginationScroll] = useState({from: 0, to: 15, total: 0, size: 15, originHeight: null});
    
 

    const argsCommon = {
        ...props,
        blockFieldListId: blockFieldListId,
        API: props?.API,
        isUsingProjectCheckbox: true,
        isIndexNumber: true,
        corporationDetail: corporationDetail,
        userDetail: userDetail,
        projectDetail: projectDetail,
        projectList: projectList,
        systemFieldList: systemFieldList,

        newFieldId: newFieldId,
        setNewFieldId: setNewFieldId,

        fieldRefList: fieldRefList,
        setFieldRefList: setFieldRefList,

        isAutoScrollToAddField: isAutoScrollToAddField,
        setIsAutoScrollToAddField: setIsAutoScrollToAddField,

        formList: formList,
        fieldListInState: fieldListInState,
        fieldList: fieldList,
        fieldAddList: fieldAddList,
        fieldTypeSelectedList: fieldTypeSelectedList,

        setIsLoading: props.setIsLoading,
        setFieldListInState: setFieldListInState,
        setFieldList: setFieldList,
        setFieldAddList: setFieldAddList,
        setFieldTypeSelectedList: setFieldTypeSelectedList,

        handleClick: handleClick,
        handleClose: handleClose,
        setCurrentFieldSelected: setCurrentFieldSelected,
        isOpenConfirmDeleteModal: isOpenConfirmDeleteModal,
        setIsOpenConfirmDeleteModal: setIsOpenConfirmDeleteModal,

        enqueueSnackbar: enqueueSnackbar,

        panelScreen,
        setPanelScreen,


        currentUpdateField: currentUpdateField,
        setCurrentUpdateField: setCurrentUpdateField,

        parentPanelScreen: parentPanelScreen,
        setParentPanelScreen: setParentPanelScreen,

        fieldUseList: fieldUseList,
        setFieldUseList: setFieldUseList,

        fieldSystemUseList: fieldSystemUseList,
        setFieldSystemUseList: setFieldSystemUseList,

        settingSlideRecoilState: settingSlideRecoilState,
        setSettingSlideRecoilState: setSettingSlideRecoilState,

        fieldDragDropList: fieldDragDropList,
        setFieldDragDropList: setFieldDragDropList,

        fieldLisForUpdate: fieldLisForUpdate,
        setFieldLisForUpdate: setFieldLisForUpdate,

        fieldFilter: fieldFilter,
        setFieldFilter: setFieldFilter,

        setSystemFieldList: setSystemFieldList,
        setFieldUnUseList: setFieldUnUseList,
        setFieldSystemUnUseList: setFieldSystemUnUseList,
        setIsChangeData: setIsChangeData,
        isChangeData: isChangeData,
        isEditedData:isEditedData,
        setIsEditedData: setIsEditedData,
        
        setIsAllFieldValid: setIsAllFieldValid,
        isConfirmCancelTabs,
        setIsConfirmCancelTabs,
        panelList,
        setPanelList,
        closePanelTab,
        triggerReload,
        setTriggerReload,
        listIdOfListUseField: listIdOfListUseField,
        listFormOfAffiliationProject: listFormOfAffiliationProject,
        setIsOpenPopupCannotInactiveField: setIsOpenPopupCannotInactiveField

    };
    
    useEffect(() => {
        props.setIsLoading(true);
        getFieldListInCorp(props?.API, corporationDetail.id, projectDetail).then(list => {
            const listFields = list?.filter(field => !DONT_DISPLAY_SYS_FIELDS?.includes(field?.sysField));
            setFieldListInState(listFields);

            let listFieldShared = list.filter(
                item => item.affiliationOrganization !== corporationDetail.id
            );
            listFieldShared = listFieldShared.map((item, index) => item.affiliationOrganization);
            listFieldShared = [...new Set(listFieldShared)];

            let listCorpShared = props.allListCorp.filter(item =>
                listFieldShared.includes(item.id)
            );
            listCorpShared = Utils.sortListByNameCorpDictionaryASC(listCorpShared);
            setListCorpSharedField(listCorpShared);
            props.setIsLoading(false);
        });
    }, [corporationDetail.id, props.allListCorp, triggerReload]);

    useEffect(() => {
        if (props.tabId === closeTabIdState) {
            if (
                isChangeData ||
                (isCancelAddFieldTag &&
                    panelScreen === Constant.FORM_MANAGEMENT_SCREEN.ADD_FIELD_TAG_ITEM) ||
                (isCancelAddFieldStatus &&
                    panelScreen === Constant.FORM_MANAGEMENT_SCREEN.ADD_FIELD_STATUS_ITEM)
            ) {
                setIsConfirmCancelTabs(true);
            } else {
                let currentPanelInfo = Utils.getPanelInfo(props.panelId, panelList);
                if (!currentPanelInfo || Utils.isEmptyObject(currentPanelInfo)) return;
                closePanelTab({
                    event: null,
                    panelType: currentPanelInfo.type,
                    panelId: props.panelId,
                    tabId: props.tabId
                });
            }
            setCloseTabIdState(0);
        }
    }, [closeTabIdState]);

    useEffect(() => {
        // init field drag/drop list
        let fieldDragDropListClone = fieldUseList
            .concat(fieldTypeSelectedList)
            .filter(
                field =>
                    field.definition !== Constant.FORM_DEFINITION.SYSTEM ||
                    ![...TmpHiddenSystemField, ...AISystemField].includes(field.sysField)
            );

        let map = fieldDragDropListClone.map(field => field.sysField);
        setFieldDragDropList(sortFieldListByOrder(fieldDragDropListClone, projectDetail));
        if (fieldDragDropList.length > 0) {
            setUseButtonCollapse(false);
        }
    }, [fieldTypeSelectedList]);
    // }, [fieldTypeSelectedList, fieldUseList]);

    useEffect(() => {
        // auto scroll to edit field
        autoScrollToEditField(argsCommon);
    }, [panelScreen, fieldRefList, currentUpdateField]);

    useEffect(() => {
        let formOfProject = [];
        argsCommon.formList?.forEach(form => {
            if (form.affiliationProject === projectDetail.id) {
                let newForm  = {...form}
                const structure = Utils.convertJSONDataToObject(form.structure);
                newForm.settingTitle = structure.formTitle;
                let listFiledIdOfTitle = [];
                if (!Utils.isEmptyArray(structure.formTitle)) {
                    structure.formTitle.forEach(field => {
                        if (!Utils.isEmptyString(field.id)) listFiledIdOfTitle.push(field.id);
                    });
                }
                newForm.listFiledIdOfTitle = listFiledIdOfTitle
                formOfProject.push(newForm);
            }
        });
        setListFormOfAffiliationProject(formOfProject);
    }, [formList, projectDetail]);

    useEffect(() => {
        // init observer auto scroll add new field
        const observerAddField = initObserverAddField(argsCommon);

        // clenaup the observer if component unmount
        return () => {
            observerAddField.disconnect();
        };
    }, [isAutoScrollToAddField]);

    // build system field
    const buildSystemField = () => {
        // field list: use, unuse
        let fieldSystemUnUseListForUpdate = [];
        let fieldSystemUseListForUpdate = [];

        // update ref list
        let refsListClone = { ...fieldRefList };

        // set isUsingProject
        let systemFieldListOfRender = cloneDeep(systemFieldList);
        systemFieldListOfRender.forEach(field => {
            if (field.usage === Constant.FORM_USAGE.FIELD) {
                refsListClone[field.id] = createRef();
                field.isUsingProject =
                    (isUsingSystemFormInvite && field.noInFormInvite) ||
                    (isUsingSystemFormQA && field.noInFormQA) ||
                    (isUsingSystemFormExternalDeskRequest && field.noInFormExternalDeskRequest) ||
                    (isUsingSystemFormCustomerInvite && field.noInFormGuestCustomerInvitation);

                // push data
                if (field.isUsingProject) {
                    fieldSystemUseListForUpdate.push(field);
                } else {
                    fieldSystemUnUseListForUpdate.push(field);
                }
            }
        });
        
        setFieldSystemUseList(fieldSystemUseListForUpdate);
        setFieldSystemUnUseList(fieldSystemUnUseListForUpdate);
    };

    useEffect(() => {
        // build system use/unuse
        buildSystemField();

        // update ref list
        let refsListClone = { ...fieldRefList };

        // set isUsingProject
        let fieldListOfRender = cloneDeep(fieldListInState);
        fieldListOfRender.forEach(field => {
            refsListClone[field.id] = createRef();

            let isUsingProject =
                !Utils.isEmptyArray(field.usingProjects) &&
                field.usingProjects.includes(projectDetail.id);
            field.isUsingProject = isUsingProject;
        });
        setFieldList(fieldListOfRender);

        if (fieldFilter?.type !== 'all' || fieldFilter?.usingForm !== 'all') {
            let cloneDeepArgsCommon = cloneDeep(argsCommon);
            cloneDeepArgsCommon.fieldListInState = fieldListOfRender;
            handleEventChangeFieldFilter(fieldFilter, cloneDeepArgsCommon);
        }

        setFieldRefList(refsListClone);
    }, [fieldListInState]);

    useEffect(() => {
        const fieldTypeSelectedListClone = [...fieldTypeSelectedList];
        // build system use/unuse
        buildSystemField();

        // field list: use, unuse
        let fieldUseListForUpdate = [];
        let fieldUnUseListForUpdate = [];
        let listIdOfUseListField = []

        // set isUsingProject

        let fieldListOfRender = cloneDeep(fieldList);
        fieldListOfRender.forEach(field => {
            let isUsingProject =
                !Utils.isEmptyArray(field.usingProjects) &&
                field.usingProjects.includes(projectDetail.id);
            field.isUsingProject = isUsingProject;

            if (field.isUsingProject) {
                fieldUseListForUpdate.push(field);
                listIdOfUseListField.push(field.id)
            } else {
                // don't put status field of other project
                if (
                    !(
                        (field.type === Constant.FORM_TYPE.FIELD_WORKFLOW &&
                            field.affiliationProject !== projectDetail.id) ||
                        (field.sysField && [...TmpHiddenSystemField, ...AISystemField].includes(field.sysField))
                    )
                ) {
                    fieldUnUseListForUpdate.push(field);
                }
            }
        });

        fieldUseListForUpdate = sortFieldListByOrder(fieldUseListForUpdate, projectDetail.id);


        

        setListIdOfListUseField([...listIdOfUseListField])
        setFieldUseList(fieldUseListForUpdate);
        setFieldUnUseList(sortFieldListByDictionary(fieldUnUseListForUpdate));

        let fieldDragDropListClone = fieldUseListForUpdate
            .concat(fieldTypeSelectedListClone)
            .filter(
                field =>
                    field.definition !== Constant.FORM_DEFINITION.SYSTEM ||
                    ![...TmpHiddenSystemField, ...AISystemField].includes(field.sysField)
            );

        fieldDragDropListClone.map(field => field.sysField);
        setFieldDragDropList(sortFieldListByOrder(fieldDragDropListClone, projectDetail));
        if (fieldDragDropList.length > 0) {
            setUseButtonCollapse(false);
        }
    }, [fieldList]);

    /* useEffect(() => {
        let input = $('.fieldSetting').find(':input[type=text]');
        if (input.length > 0) {
            let enableButton = true;
            input.map((index, item) => {
                if (
                    $(item).val().length < 1 &&
                    item.placeholder !== '正規表現で入力してください' &&
                    !item.ariaAutoComplete
                ) {
                    enableButton = false;
                    return;
                }
            });
            setIsChangeData(enableButton);
        }
    }, [fieldAddList, isAutoScrollToAddField]); */

    const checkDisableButtonSubmit = () => {  
        if (!isChangeData) {
            return true;
        }
        let isDisable = false;
        fieldAddList?.forEach(field => {
            if (!isDisable) {
                if (!Utils.isEmptyObject(field?.errors?.name)) {
                    isDisable = true;
                    return isDisable;
                }

                if (typeof field?.name === 'object') {
                    if (!field?.name?.jp?.text) {
                        isDisable = true;
                        return isDisable;
                    }
                    let validateShareRange =
                        [
                            Constant.SHARE_OPTION.SPECIFIC_ORG,
                            Constant.SHARE_OPTION.B2B_CUSTOMER_ORG,
                            Constant.SHARE_OPTION.B2B_HELPDESK_ORG
                        ].includes(field?.newShareOption) &&
                        Utils.isEmptyArray(field?.newShareRange);
                    if (validateShareRange) {
                        isDisable = true;
                        return isDisable;
                    }
                }
            }
        });

        

        return isDisable;
    }
    const hanldeUseButtonCollapse = () => {
        if (useButtonCollapse === true) {
            setUseButtonCollapse(false);
        } else {
            setUseButtonCollapse(true);
        }
    };

    const hanldeUnUseButtonCollapse = () => {
        if (unUseButtonCollapse === true) {
            setUnUseButtonCollapse(false);
        } else {
            
            setUnUseButtonCollapse(true);
            const paginationScrollClone = {...paginationScroll};
            paginationScrollClone.to = 15;
            setPaginationScroll(paginationScrollClone);
        }
    };

    const handleAddFieldShow = () => {
        if (addFieldShow === true) {
            setAddFieldShow(false);
        } else {
            setAddFieldShow(true);
        }
    };

    /** handler click field type selected */
    const onClickFieldTypeSelected = fieldType => {

        let saveOrder = getNewOrderForNewField(fieldDragDropList, projectDetail.id, fieldListInState, fieldAddList);
        let fieldId = `dummy_${Date.now().toString()}`;

        

        // init refs
        let refsListClone = cloneDeep(fieldRefList);
        refsListClone[fieldId] = createRef();
        

        // build field by fieldType
        let fieldDataInput = {
            id: fieldId,
            usingProjects: [projectDetail.id],
            // order: { [`${projectDetail.id}`]: fieldUseList.length }
            order: { [`${projectDetail.id}`]: saveOrder },
            saveOrder: { [`${projectDetail.id}`]: saveOrder }
        };
        

        ReactDOM.unstable_batchedUpdates(() => {
            setFieldTypePopover(null);

            // update new fieldId
            setNewFieldId(fieldId);

            setFieldRefList(refsListClone);

            // set auto scroll to add field
            setIsAutoScrollToAddField(true);

            setUseButtonCollapse(false);
            
            setIsChangeData(false);
            addFieldNew(fieldType, argsCommon, fieldDataInput);
        });
        
    };

    const getOrgName = orgId => {
        const orgDetail = props?.allListCorp?.find(org => {
            return org.id === orgId;
        });

       let orgName = Utils.isEmptyString(orgDetail?.title) ? '' : orgDetail?.title;
        return orgDetail?.active === Constant.CORPORATION_ACTIVE.BLOCK ? `${orgName} (停止中)`: orgName;
    };

    const handleOnScroll = (e) => {
        let target = e.target;
        const paginationScrollClone = {...paginationScroll};
        const beforeBottom = target.scrollHeight - 30;
        let updateState = false;
        // if (paginationScrollClone.originHeight === null) {
        //     paginationScrollClone.originHeight = target.scrollHeight;
        //     updateState = true;
        // }
        // show before to bottom
        
        if (target.offsetHeight + target.scrollTop > beforeBottom && unUseButtonCollapse === false) {
            updateState = true;
            paginationScrollClone.to = paginationScrollClone.to + 15;
            // if (paginationScrollClone.to - paginationScrollClone.from > 50 && paginationScrollClone.to - 50 >= 0) {
            //     paginationScrollClone.from = paginationScrollClone.to - 50;
            // }
            
        } 

        // if (paginationScrollClone.originHeight + 50 > target.offsetHeight + target.scrollTop && paginationScrollClone.from > 0) {

        // }

        if (updateState) setPaginationScroll(paginationScrollClone);
    }

    const accordionUsedItemForm = () => {
        return (
            <>
                <div className="accordionContent">
                    <div className="fieldSetting"  
                    // onScroll={e => {
                    //     console.log('onScroll :>> ', 1);
                    //     let isOnBottom  = e.currentTarget.scrollHeight- e.currentTarget.scrollTop === e.currentTarget.clientHeight;
                    //         if(isOnBottom){
                    //             let fieldDragDropListClone = [...fieldDragDropList,...fieldDragDropList];
                    //             setFieldDragDropList(fieldDragDropListClone)
                    //         }
                    //     }}
                        >
                        {/* field list use */}
                        {/* system field */}

                        {/* custom field */}
                        <DragDropContext
                            onDragEnd={event => onDragEndHandlerFieldList(event, argsCommon)}
                            onBeforeDragStart={event =>
                                onBeforeDragStartHandlerFieldList(event, argsCommon)
                            }
                        >
                            <Droppable droppableId="droppable">
                                {(provided, snapshot) => (
                                    <ul
                                        className="listForm-ul"
                                        id={blockFieldListId}
                                        ref={provided.innerRef}
                                        data-cy="field-list-active-custom"
                                    >
                                        {/**Exclude  */}
                                        {fieldDragDropList.map((field, index) => {
                                            return (
                                                <Draggable
                                                    key={field.id}
                                                    draggableId={`${field.id}`}
                                                    index={index}
                                                >
                                                    {(childProvided, snapshot) => {
                                                        if (snapshot.isDragging) {
                                                            childProvided.draggableProps.style.left =
                                                                'auto!important';
                                                        }
                                                        return (
                                                            <li
                                                                className={
                                                                    isUseFieldInForm(
                                                                        field,
                                                                        formList,
                                                                        argsCommon
                                                                    )
                                                                        ? 'listField-li'
                                                                        : 'listField-li background-color-usingForm'
                                                                }
                                                                id={field.id}
                                                                key={field.id}
                                                                ref={fieldRefList[field.id]}
                                                                data-cy="field-item"
                                                            >
                                                                <div
                                                                    ref={childProvided.innerRef}
                                                                    {...childProvided.draggableProps}
                                                                    {...childProvided.dragHandleProps}
                                                                    data-cy="field-list-active-custom-item"
                                                                    className="fieldSetting-info"
                                                                >
                                                                    {renderFieldItem(field)}
                                                                </div>
                                                            </li>
                                                        );
                                                    }}
                                                </Draggable>
                                            );
                                        })}
                                        {provided.placeholder}
                                    </ul>
                                )}
                            </Droppable>
                        </DragDropContext>
                    </div>
                    {/* fieldSetting */}
                </div>
            </>
        );
    };

    // const isChangeFieldUnUseList = (fieldUnUseList, prevFieldUnUseList) => {
        
    // }   

    const accordionUnUsedItemForm = () => {
        
        if (unUseButtonCollapse) {
            return (
                <>
                    <div className="accordionContent"></div>
                </>
            )
        }

        return (
            <>
                <div className="accordionContent">
                    <div className="fieldSetting">
                        <ul className="listForm-ul" id={blockFieldListId}>
                            {/* {fieldSystemUnUseList.map(field => {
                                return (
                                    <>
                                        <li
                                            className={
                                                isUseFieldInForm(field, formList, argsCommon)
                                                    ? 'listField-li'
                                                    : 'listField-li background-color-usingForm'
                                            }
                                            data-cy="field-item"
                                        >
                                            <div
                                                data-cy="field-list-active-custom-item"
                                                className="fieldSetting-info"
                                            >
                                                {renderFieldItem(field)}
                                            </div>
                                        </li>
                                    </>
                                );
                            })} */}

                            {/* render field custom list */}
                            {/* <UnUsedItemField 
                                originItemList={fieldUnUseList}
                                renderFieldItem={renderFieldItem}
                                isUseFieldInForm={isUseFieldInForm}
                                argsCommon={argsCommon}
                                formList={formList}
                            /> */}
                            {fieldUnUseList.map((field, index) => {
                                if (paginationScroll.to > index) {
                                    return (
                                        <>
                                            <li className={
                                                    isUseFieldInForm(field, formList, argsCommon)
                                                        ? 'listField-li'
                                                        : 'listField-li background-color-usingForm'
                                                }
                                                data-cy="field-item"
                                                key={field.id}
                                            >
                                                <div
                                                    data-cy="field-list-active-custom-item"
                                                    className="fieldSetting-info"
                                                >
                                                   {renderFieldItem(field)}
                                                </div>
                                            </li>
                                        </>
                                    );
                                }
                            })}

                            {/* render add field */}
                            {fieldTypeSelectedList.map(fieldType => {
                                return Utils.isEmptyArray(fieldType.usingProjects) ? (
                                    getAddFieldByFieldType(argsCommon, fieldType)
                                ) : (
                                    <></>
                                );
                            })}

                            {/* render field system list */}
                        </ul>
                    </div>
                    {/* fieldSetting */}
                </div>
            </>
        );
    };

    /** render field item */
    const renderFieldItem = field => {
        return (
            <>
                {/* expand more field */}
                {field.isShowInfo &&  getAddFieldByFieldType(argsCommon, field)}
                {/* detail field */}
                {!field.isShowInfo && (
                    <>
                        <div className="fieldSetting-thumb">
                            {/* get images by type field */}
                            <img src={`${getIconFieldByTypeField(field)}`} alt="" />
                        </div>
                        <div className="fieldSetting-cmt">
                            <div
                                className="fieldSetting-name"
                                onDoubleClick={e => {
                                    if (
                                        ([
                                            Constant.FORM_TYPE.FIELD_URL,
                                            Constant.FORM_TYPE.FIELD_IFRAME
                                        ].includes(field.type) &&
                                            !isEditField(field, argsCommon)) ||
                                        field.sysField
                                    ) {
                                        return;
                                    }
                                    // DOUBLE CLICK Event
                                    showFieldInfo(argsCommon, field);
                                }}
                            >
                                <div className="fieldSetting-tlt">
                                    <OverFlowTooltipWithTabsMui
                                        value={Utils.getTextByLanguage(
                                            Constant.LANGUAGE_TYPE.JP,
                                            field.name
                                        )}
                                    ></OverFlowTooltipWithTabsMui>
                                </div>
                                {field?.affiliationOrganization === corporationDetail.id && (
                                    <p className="fieldSetting-text  --2">
                                        {getProjectNameOfField(field, projectList)}
                                    </p>
                                )}
                                {field?.affiliationOrganization !== corporationDetail.id && (
                                    <p className="fieldSetting-text  --3">
                                        {getOrgName(field?.affiliationOrganization)}
                                    </p>
                                )}
                                {field.isErrorValidate && (
                                    <>
                                        <br />
                                        <span className="message-error">
                                            フィールド名をご記入ください。
                                        </span>
                                    </>
                                )}
                            </div>
                            {(!isSystemField(field) || field.sysField === 'outline') &&
                                !isAddNewField(field) && (
                                    <div className="fieldSetting-autofill">
                                        {/* <p className="fieldSetting-text">自動入力</p> */}
                                        <div
                                            className={
                                                isUseFieldInForm(field, formList, argsCommon)
                                                    ? 'fieldSetting-item'
                                                    : 'fieldSetting-item background-color-usingForm'
                                            }
                                        >
                                            {!field.isProjectInuse &&
                                                field.definition !==
                                                    Constant.FORM_DEFINITION.SYSTEM &&
                                                field.type !==
                                                    Constant.FORM_TYPE.FIELD_WORKFLOW && (
                                                    <>
                                                        <IconButton
                                                            className="itemTools"
                                                            aria-label="more"
                                                            id="long-button"
                                                            aria-controls={
                                                                open ? 'long-menu' : undefined
                                                            }
                                                            aria-expanded={
                                                                open ? 'true' : undefined
                                                            }
                                                            aria-haspopup="true"
                                                            onClick={event => {
                                                                handleClick(event);
                                                                setMoreActionPopover(
                                                                    event.currentTarget
                                                                );
                                                                setCurrentFieldSelected(field);
                                                                setPopoverId(field.id);
                                                            }}
                                                        >
                                                            <img
                                                                src="/assets/image/icon-nav-manage.svg"
                                                                alt=""
                                                            />
                                                        </IconButton>
                                                        <Popover
                                                            className="nav-addManage"
                                                            id={open ? 'simple-popover' : undefined}
                                                            open={open && popoverId === field.id}
                                                            anchorEl={anchorEl}
                                                            onClose={handleClose}
                                                            anchorOrigin={{
                                                                vertical: 'top',
                                                                horizontal: 'right'
                                                            }}
                                                        >
                                                            <ul>
                                                                {!isAddNewField(
                                                                    currentFieldSelected
                                                                ) && (
                                                                    <li
                                                                        id={`${field.id}_duplicate`}
                                                                        onClick={e => {
                                                                            handleClose();
                                                                            setMoreActionPopover(
                                                                                null
                                                                            );
                                                                            duplicateField(
                                                                                argsCommon,
                                                                                currentFieldSelected
                                                                            );
                                                                            setIsChangeData(true);
                                                                        }}
                                                                        data-cy="item-field-icon-duplicate"
                                                                    >
                                                                        <span className="item">
                                                                            <img
                                                                                src="/assets/image/icon-copy.svg"
                                                                                alt=""
                                                                            />
                                                                        </span>
                                                                        <span className="text">
                                                                            {I18n.get(
                                                                                'FIELDFORMBTN013'
                                                                            )}
                                                                        </span>
                                                                    </li>
                                                                )}

                                                                {isPermissionDeleteField(
                                                                    currentFieldSelected,
                                                                    formList,
                                                                    argsCommon
                                                                ) &&
                                                                    projectDetail.id ===
                                                                        field.affiliationProject && (
                                                                        <li
                                                                            id={`${field.id}_delete`}
                                                                            onClick={event => {
                                                                                handleClose();
                                                                                setIsOpenConfirmDeleteModal(
                                                                                    true
                                                                                );
                                                                            }}
                                                                            data-cy="item-field-icon-delete"
                                                                        >
                                                                            <span className="item">
                                                                                <img
                                                                                    src="/assets/image/icon-tabs-delete.svg"
                                                                                    alt=""
                                                                                />
                                                                            </span>
                                                                            <span className="text">
                                                                                {I18n.get(
                                                                                    'USER01LB006'
                                                                                )}
                                                                            </span>
                                                                        </li>
                                                                    )}
                                                            </ul>
                                                        </Popover>
                                                    </>
                                                )}

                                            {/* bookmark unuse */}
                                            {!field.isUsingProject &&
                                                !ForceActiveSystemFields.includes(
                                                    field.sysField
                                                ) && (
                                                    <IconButton
                                                        className="itemTools"
                                                        data-cy="item-field-icon-bookmark-inactive"
                                                        onClick={event =>
                                                            onClickUsingProjects(
                                                                argsCommon,
                                                                field,
                                                                true,
                                                                projectDetail
                                                            )
                                                        }
                                                    >
                                                        <img
                                                            src="/assets/image/icon-pin-outline.svg"
                                                            alt=""
                                                        />
                                                    </IconButton>
                                                )}

                                            {/* bookmark use */}
                                            {renderBookmarkUsing(field)}

                                            {!isSystemField(field) && (
                                                <IconButton
                                                    className="itemTools"
                                                    onClick={e => showFieldInfo(argsCommon, field)}
                                                >
                                                    <img
                                                        src="/assets/image/icon-arrow-accordion-gray.svg"
                                                        alt=""
                                                    />
                                                </IconButton>
                                            )}
                                        </div>
                                    </div>
                                )}

                            {!isSystemField(field) && isAddNewField(field) && (
                                <div className="fieldSetting-autofill">
                                    <div
                                        className={
                                            isUseFieldInForm(field, formList, argsCommon)
                                                ? 'fieldSetting-item'
                                                : 'fieldSetting-item background-color-usingForm'
                                        }
                                        style={{ display: 'flex' }}
                                    >
                                        {/* Remove duplicate field */}
                                        {isAddNewField(field) && (
                                            <IconButton
                                                className="itemTools"
                                                onClick={event => {
                                                    removeFieldInFieldList(argsCommon, field);
                                                }}
                                            >
                                                <img
                                                    src="/assets/image/icon-tabs-delete.svg"
                                                    alt=""
                                                />
                                            </IconButton>
                                        )}

                                        <IconButton
                                            className="itemTools"
                                            onClick={e => showFieldInfo(argsCommon, field)}
                                        >
                                            <img
                                                src="/assets/image/icon-arrow-accordion-gray.svg"
                                                alt=""
                                            />
                                        </IconButton>
                                    </div>
                                </div>
                            )}
                        </div>
                    </>
                )}
            </>
        );
    };

    const renderBookmarkUsing = field => {
        if (
            field.isUsingProject &&
            !ForceActiveSystemFields.includes(field.sysField) &&
            field.type !== Constant.FORM_TYPE.FIELD_WORKFLOW &&
            !ForceActiveSystemFields.includes(field.sysField)
        ) {
            return (
                <IconButton
                    className="itemTools"
                    data-cy="item-field-icon-bookmark-active"
                    onClick={event => onClickUsingProjects(argsCommon, field, false, projectDetail)}
                >
                    <img src="/assets/image/icon-pin.svg" alt="" />
                </IconButton>
            );
        }
        return <></>;
    };


    const renderHeader = () => {
     

        return (
            <>
                <div className="headManage">
                    <div className="headManage-top">
                        <h2 className="headManage-title">フィールド一覧</h2>
                        <div className="headManage-tools">
                            <div className="headManage-item">
                                {/* <IconButton className="itemTools">
                                    <img src="/assets/image/icon-up.svg" alt="" />
                                </IconButton>
                                <IconButton className="itemTools">
                                    <img src="/assets/image/icon-dow.svg" alt="" />
                                </IconButton> */}
                            </div>
                            <div className="keep">
                                <Button
                                    className="btn-primary btn-hg32"
                                    data-cy="field-list-btn-submit"
                                    variant="contained"
                                    onClick={event => {
                                        onSubmitAddField(argsCommon);
                                        handleClose();
                                    }}
                                    disabled={checkDisableButtonSubmit()}
                                >
                                    保存
                                </Button>
                            </div>
                        </div>
                    </div>
                    {/* <UnUsedItemField /> */}
                    {/* headManage-top */}
                    {/* formSearch formSearch--col3 */}
                    <div className="formSearch formSearch--col2">
                        <div className="formSearch-info">
                            <label className="formSearch-label">定義</label>
                            <div className="formSearch-control">
                                <TextField
                                    className="form-control--wrap form-control--hg32"
                                    select
                                    variant="outlined"
                                    SelectProps={{
                                        MenuProps: {
                                            anchorOrigin: {
                                                vertical: 'bottom',
                                                horizontal: 'left'
                                            },
                                            getContentAnchorEl: null,
                                            className: 'selectDrop'
                                        }
                                    }}
                                    onChange={event => {
                                        let fieldFilterClone = cloneDeep(fieldFilter);
                                        fieldFilterClone.type = event.target.value;
                                        setFieldFilter(fieldFilterClone);
                                        handleEventChangeFieldFilter(fieldFilterClone, argsCommon);
                                    }}
                                    value={fieldFilter.type}
                                >
                                    <MenuItem value="all">全て</MenuItem>
                                    <MenuItem value={Constant.FORM_DEFINITION.SYSTEM}>
                                        システム
                                    </MenuItem>
                                    <MenuItem value={Constant.FORM_DEFINITION.SAMPLE}>
                                        SysAdmin
                                    </MenuItem>
                                    <ListSubheader
                                        className="fontw-bold select-item"
                                        color="inherit"
                                        disableSticky
                                        onClickCapture={e => e.stopPropagation()}
                                    >
                                        {I18n.get('FIELDFORMLB044')}
                                    </ListSubheader>
                                    {projectList &&
                                        sortProjectByprojectInuseAndDictionary(
                                            projectDetail,
                                            getSelectProjectList(projectList)
                                        ).map(item => (
                                            <MenuItem key={item.id} value={item.id}>
                                                {Utils.getTextByLanguage(
                                                    Constant.LANGUAGE_TYPE.JP,
                                                    item.name
                                                )}
                                            </MenuItem>
                                        ))}
                                    <ListSubheader
                                        className="fontw-bold select-item"
                                        color="inherit"
                                        disableSticky
                                        onClickCapture={e => e.stopPropagation()}
                                    >
                                        {I18n.get('FIELDFORMLB045')}
                                    </ListSubheader>
                                    {listCorpSharedField &&
                                        listCorpSharedField.map(item => (
                                            <MenuItem key={item.id} value={item.id}>
                                                <OverFlowTooltipWithTabsMui value={item.title} />
                                            </MenuItem>
                                        ))}
                                </TextField>
                            </div>
                        </div>
                        <div className="formSearch-info">
                            <label className="formSearch-label">利用状況</label>
                            <div className="formSearch-control">
                                <TextField
                                    className="form-control--wrap form-control--hg32"
                                    select
                                    variant="outlined"
                                    SelectProps={{
                                        MenuProps: {
                                            anchorOrigin: {
                                                vertical: 'bottom',
                                                horizontal: 'left'
                                            },
                                            getContentAnchorEl: null,
                                            className: 'selectDrop'
                                        }
                                    }}
                                    onChange={event => {
                                        let fieldFilterClone = cloneDeep(fieldFilter);
                                        fieldFilterClone.usingForm = event.target.value;
                                        setFieldFilter(fieldFilterClone);
                                        handleEventChangeFieldFilter(fieldFilterClone, argsCommon);
                                    }}
                                    value={fieldFilter.usingForm}
                                >
                                    <MenuItem value="all">全て</MenuItem>
                                    <MenuItem value="use">使用中</MenuItem>
                                    <MenuItem value="unuse">不使用</MenuItem>
                                </TextField>
                            </div>
                        </div>
                    </div>
                    {/* formSearch formSearch--col2 */}
                </div>
            </>
        );
    };

    const renderList = () => {
        return (
            <>
                {/* <div className="contentManage"  onScroll={e => handleOnScroll(e)}> */}
                    <div className={addFieldShow ? 'addField addField--show' : 'addField'}>
                        {/* Khi click vào 'div addField-accordion' thì 'div addField sẽ add addField--show' */}
                        <div className="addField-accordion">
                            <span onClick={handleAddFieldShow}>フィールドを追加</span>
                        </div>
                        <div className="addField-content">
                            <p className="fieldType">フィールドタイプを選択</p>
                            <ul>
                                <li
                                    onClick={e => {
                                        onClickFieldTypeSelected(Constant.FIELD_UI.TAG);
                                    }}
                                >
                                    <div className="addField-info">
                                        <span className="addField-item">
                                            <img src="/assets/image/icon-field.svg" alt="" />
                                        </span>
                                        <span className="addField-text">{I18n.get('TAG_TITLE')}</span>
                                    </div>
                                </li>
                                <li
                                    onClick={e => {
                                        onClickFieldTypeSelected(Constant.FIELD_UI.DATE);
                                    }}
                                >
                                    <div className="addField-info">
                                        <span className="addField-item">
                                            <img src="/assets/image/icon-field01.svg" alt="" />
                                        </span>
                                        <span className="addField-text">時間</span>
                                    </div>
                                </li>
                                <li
                                    onClick={e => {
                                        onClickFieldTypeSelected(Constant.FIELD_UI.TEXT);
                                    }}
                                >
                                    <div className="addField-info">
                                        <span className="addField-item">
                                            <img src="/assets/image/icon-field02.svg" alt="" />
                                        </span>
                                        <span className="addField-text">テキスト</span>
                                    </div>
                                </li>
                                <li
                                    onClick={e => {
                                        onClickFieldTypeSelected(Constant.FIELD_UI.NUMBER);
                                    }}
                                >
                                    <div className="addField-info">
                                        <span className="addField-item">
                                            <img src="/assets/image/icon-field03.svg" alt="" />
                                        </span>
                                        <span className="addField-text">数字</span>
                                    </div>
                                </li>
                                {/* <li>
                                    <div className="addField-info">
                                        <span className="addField-item">
                                            <img src="/assets/image/icon-field04.svg" alt="" />
                                        </span>
                                        <span className="addField-text">ステータス</span>
                                    </div>
                                </li>
                                <li
                                    onClick={e =>
                                        onClickFieldTypeSelected(Constant.FIELD_UI.IFRAME)
                                    }
                                >
                                </li> */}
                                <li
                                    onClick={e =>
                                        onClickFieldTypeSelected(Constant.FIELD_UI.IFRAME)
                                    }
                                >
                                    <div className="addField-info">
                                        <span className="addField-item">
                                            <img src="/assets/image/icon-field05.svg" alt="" />
                                        </span>
                                        <span className="addField-text">iFrame</span>
                                    </div>
                                </li>
                                <li
                                    onClick={e => {
                                        onClickFieldTypeSelected(Constant.FIELD_UI.URL);
                                    }}
                                >
                                    <div className="addField-info">
                                        <span className="addField-item">
                                            <img src="/assets/image/icon-field06.svg" alt="" />
                                        </span>
                                        <span className="addField-text">URL</span>
                                    </div>
                                </li>
                                <li
                                    onClick={e => {
                                        onClickFieldTypeSelected(Constant.FIELD_UI.FIELD_RICHTEXT);
                                    }}
                                >
                                    <div className="addField-info">
                                        <span className="addField-item">
                                            <img src="/assets/image/icon-field07.svg" alt="" />
                                        </span>
                                        <span className="addField-text">リッチテキスト</span>
                                    </div>
                                </li>
                                <li
                                    onClick={e => {
                                        onClickFieldTypeSelected(Constant.FIELD_UI.MERMAID);
                                    }}
                                >
                                    <div className="addField-info">
                                        <span className="addField-item">
                                            <img src="/assets/image/mermaid-icon.svg" alt="" />
                                        </span>
                                        <span className="addField-text">{I18n.get('MERMAID')}</span>
                                    </div>
                                </li>
                                <li
                                    onClick={e => {
                                        onClickFieldTypeSelected(Constant.FIELD_UI.HTML);
                                    }}
                                >
                                    <div className="addField-info">
                                        <span className="addField-item">
                                            <img src="/assets/image/html-icon.svg" alt="" />
                                        </span>
                                        <span className="addField-text">{I18n.get('HTML')}</span>
                                    </div>
                                </li>

                                {/* <li>
                                    <div className="addField-info">
                                        <span className="addField-item">
                                            <img src="/assets/image/icon-field08.svg" alt="" />
                                        </span>
                                        <span className="addField-text">添付</span>
                                    </div>
                                </li>
                                <li>
                                    <div className="addField-info">
                                        <span className="addField-item">
                                            <img src="/assets/image/icon-field09.svg" alt="" />
                                        </span>
                                        <span className="addField-text">ビデオ</span>
                                    </div>
                                </li> */}
                            </ul>
                        </div>
                    </div>
                    {/* addField */}
                    <div
                        className={
                            !useButtonCollapse
                                ? 'accordionForm accordionForm--show'
                                : 'accordionForm'
                        }
                    >
                        <div className="accordionHead" onClick={hanldeUseButtonCollapse}>
                            <span className="accordionHead-item">
                                <img src="/assets/image/icon-pin.svg" alt="" />
                            </span>
                            <span className="accordionHead-text">
                                以下のフィールドは使用する ({fieldDragDropList.length})
                            </span>
                        </div>
                        {/* Khi click vào 'div accordionHead' thì 'div accordionForm sẽ add accordionForm--show' */}

                        {accordionUsedItemForm()}
                    </div>
                    
                      <div
                        className={
                            !unUseButtonCollapse
                                ? 'accordionForm accordionForm--show'
                                : 'accordionForm'
                        }
                    >
                        
                        <div className="accordionHead" onClick={hanldeUnUseButtonCollapse}>
                            <span className="accordionHead-item">
                                <img src="/assets/image/icon-pin-outline.svg" alt="" />
                            </span>
                            <span className="accordionHead-text">
                                以下のフィールドは使用しない ({fieldUnUseList.length})
                            </span>
                        </div>
                        {accordionUnUsedItemForm()}
                    </div>
                {/* </div> */}
            </>
        );
    };

    const callbackAddFieldTag = isCancel => {
        setIsCancelAddFieldTag(isCancel);
    };

    const callbackAddFieldStatus = isCancel => {
        setIsCancelAddFieldStatus(isCancel);
    };

    return (
        <div className="groupManage">
            {/* headManage */}
            {![
                Constant.FORM_MANAGEMENT_SCREEN.ADD_FIELD_TAG_ITEM,
                Constant.FORM_MANAGEMENT_SCREEN.ADD_FIELD_STATUS_ITEM
            ].includes(panelScreen) && (
                renderHeader()
            )}

            {/* contentManage */}
            

            
            {panelScreen === Constant.FORM_MANAGEMENT_SCREEN.LIST_FIELD && (
                <div className="contentManage"  onScroll={e => handleOnScroll(e)}>
                    {renderList()}
                </div>
                
            )}

            {panelScreen === Constant.FORM_MANAGEMENT_SCREEN.ADD_FIELD_TAG_ITEM && (
                <AddFieldTagItem {...argsCommon} parentCallback={callbackAddFieldTag} />
            )}

            {panelScreen === Constant.FORM_MANAGEMENT_SCREEN.ADD_FIELD_STATUS_ITEM && (
                <AddFieldStatusItem {...argsCommon} parentCallback={callbackAddFieldStatus} />
            )}

            <ConfirmDeleteFieldModal
                setMoreActionPopover={setMoreActionPopover}
                isOpenConfirmDeleteModal={isOpenConfirmDeleteModal}
                setIsOpenConfirmDeleteModal={setIsOpenConfirmDeleteModal}
                submitConfirm={() => {
                    // close confirm delete modal
                    setIsOpenConfirmDeleteModal(false);
                    deleteFieldById(currentFieldSelected, argsCommon);
                }}
            />
            <CancelTabsDialog argsAll={argsCommon} />
            <Dialog
            open={isOpenPopupCannotInactiveField}
            onClose={() => setIsOpenPopupCannotInactiveField(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                className="alert-dialog-delete-addition-user"
            >
                <DialogContent>
                    <DialogContentText id="alert-dialog-delete-addition-user-content">
                    このフィールドはあるフォーマットにタイトルに設定していますので、削除もしくは使用しない事ができません。
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="confirm-delete-user-dialog-action">
                    <Button
                        onClick={() => setIsOpenPopupCannotInactiveField(false)}
                        autoFocus
                        className="btn-handle-delete-user btn-handle-delete-user-agree"
                    >
                    閉じる
                    </Button>
                    
                </DialogActions>
            </Dialog>
        </div>
    );
}
